import {styled, css} from 'styled-components';
import {bool, string, any, func, oneOfType, object} from 'prop-types';
import {forbidExtraProps} from 'airbnb-prop-types';
import isExternal from 'is-url-external';
import {unionContexts} from 'r/utils';


const Wr = styled.a`
  display: block;
  width: auto;
  text-decoration: none;
  color: inherit;
  ${props => props.$disabled && css`
    pointer-events: none;
  `}
`;

const A = styled.a`
  display: block;
  width: auto;
  text-decoration: none;
  color: inherit;
  ${props => props.$disabled && css`
    pointer-events: none;
  `}
`;


export default unionContexts(
  SmartLink,
);

SmartLink.propTypes = forbidExtraProps({
  children: any,
  className: string, // need for styled-components (when `const MyLink = styled(SmartLink)...`)
  onClick: func,
  state: object,
  to: oneOfType([object, string]).isRequired,
  disabled: bool,
  style: object,
});

function SmartLink({
  children,
  className,
  onClick,
  state,
  to,
  disabled,
  style,
}) {
  const _onClick = (...args) => {
    if (onClick) {
      onClick(...args);
    }
  };

  if (typeof to !== 'object') {
    const isMailTo = /^mailto:/.test(to);
    if ((to.startsWith('https://') || to.startsWith('http://') || isExternal(to)) && !to.startsWith('https://sanr.app') || isMailTo) {
      if (isMailTo) {
        return (
          <A
            children={children}
            $disabled={disabled}
            className={className}
            href={to}
            onClick={_onClick}
            style={style}
            target="_blank"
          />
        );
      }
      return (
        <A
          children={children}
          $disabled={disabled}
          className={className}
          href={to}
          onClick={_onClick}
          rel="noopener noreferrer"
          style={style}
          target="_blank"
        />
      );
    }
  }


  return (
    <Wr
      $disabled={disabled}
      className={className}
      onClick={_onClick}
      state={state}
      style={style}
      to={to}
    >
      {children}
    </Wr>
  );
}
